var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSamsungPay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10996",
    "data-name": "Group 10996",
    transform: "translate(-123 -398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8656",
    "data-name": "Rectangle 8656",
    transform: "translate(123 398)",
    fill: "#fff",
    stroke: "rgba(112,112,112,0.25)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_20220702025807_Samsung_Pay_Logo",
    "data-name": "20220702025807!Samsung_Pay_Logo",
    transform: "translate(133.784 408.779)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6709",
    d: "M20.564,7.265a8.732,8.732,0,0,0-2.14-4.943h0A8.732,8.732,0,0,0,13.481.183a17.948,17.948,0,0,0-3.1-.172,21.654,21.654,0,0,0-3.1.172,8.732,8.732,0,0,0-4.943,2.14h0A8.732,8.732,0,0,0,.2,7.265a20.006,20.006,0,0,0-.2,3.1,21.654,21.654,0,0,0,.172,3.1,8.733,8.733,0,0,0,2.14,4.943h0a8.732,8.732,0,0,0,4.943,2.139,17.967,17.967,0,0,0,3.1.172,21.682,21.682,0,0,0,3.1-.172A8.732,8.732,0,0,0,18.4,18.405h0a8.732,8.732,0,0,0,2.14-4.943,17.948,17.948,0,0,0,.172-3.1,16.276,16.276,0,0,0-.148-3.1",
    transform: "translate(0 0)",
    fill: "#1e4bc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6711",
    d: "M15.619,29.842v5.435h1.008V33.728h.836a1.955,1.955,0,0,0,.787-.148,2.089,2.089,0,0,0,.615-.418,1.813,1.813,0,0,0,.418-.615,2.044,2.044,0,0,0,0-1.525,1.987,1.987,0,0,0-1.033-1.033,2.04,2.04,0,0,0-.787-.147Zm.984.91h.787a1.148,1.148,0,0,1,.418.074.935.935,0,0,1,.32.221,1.4,1.4,0,0,1,.2.32,1.083,1.083,0,0,1,0,.787.868.868,0,0,1-.2.32.937.937,0,0,1-.32.221,1.148,1.148,0,0,1-.418.073H16.6V30.777Zm5.164.147a2.259,2.259,0,0,0-.811.147,1.994,1.994,0,0,0-.689.418,2.339,2.339,0,0,0-.492.689,2.463,2.463,0,0,0,.024,1.869,2.342,2.342,0,0,0,.492.689,2.465,2.465,0,0,0,.689.418,2.221,2.221,0,0,0,.787.147,2.031,2.031,0,0,0,.787-.147,1.7,1.7,0,0,0,.615-.467v.615h1.008V30.9H23.169v.565a1.816,1.816,0,0,0-.615-.418A1.955,1.955,0,0,0,21.767,30.9Zm2.755.024,1.77,4.156-.91,2.189h1.033L29,30.924H27.939L26.808,33.9l-1.23-2.976Zm-2.582.91a1,1,0,0,1,.516.123,1.226,1.226,0,0,1,.418.27,1.123,1.123,0,0,1,.27.393,1.278,1.278,0,0,1,0,.984,1.4,1.4,0,0,1-.27.393,1.523,1.523,0,0,1-.418.271,1.14,1.14,0,0,1-.516.1,1.617,1.617,0,0,1-.517-.1A1.529,1.529,0,0,1,21,34a2.416,2.416,0,0,1-.27-.418,1.278,1.278,0,0,1,0-.984A1.029,1.029,0,0,1,21,32.2a1.226,1.226,0,0,1,.418-.27A1.286,1.286,0,0,1,21.939,31.834Z",
    transform: "translate(-11.778 -22.503)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSamsungPay);
export default __webpack_public_path__ + "static/media/samsung-pay.cf9faa7b6cb73c663c6e03b845653939.svg";
export { ForwardRef as ReactComponent };